import React from 'react';
import TransportLoader from '../../components/loaders/TransportLoader';
import './LoadingShowcase.css';

export default function LoadingShowcase() {
  return (
    <div className="loading-showcase">
      <div className="loading-showcase__card">
        <h1>Vista previa del loading screen</h1>
        <p>
          Esta pantalla temporal muestra la animación de transporte encadenado (camión → barco → avión → camión).
          Utilízala para validar estilos y tiempos antes de integrarla en la aplicación principal.
        </p>
        <TransportLoader />
        <div className="loading-showcase__hint">
          <span>
            ¿Comentarios o ajustes? Dímelos y seguimos iterando antes de llevarla al flujo real.
          </span>
        </div>
      </div>
    </div>
  );
}

